
import 'components/catalog-static.tag'
import 'components/tags.tag'
import 'pages/products/groups/group-select-modal.tag'
riot.tag2('product-edit-additional-categories', '  <div class="input-group">\n    <tags class="form-control" name="{opts.name}" value="{value}"></tags><span class="input-group-addon" onclick="{add}"><i class="fa fa-plus"></i></span>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
        self.update();
    }
});

self.add = function () {
    modals.create('group-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            self.value = self.value || [];
            var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
            var ids = self.value.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) self.value.push(item);
            });

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            self.update();
            this.modalHide();
        }
    });
};

self.on('update', function () {
    if ('name' in opts && opts.name !== '') self.root.name = opts.name;

    if ('value' in opts) self.value = opts.value || [];
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-additional-categories.tag